export default {
  email: '',
  success: false,
  loading: false,
};
